import React from "react";
import { ThemeProvider } from "styled-components";
import { MatchMedia, ViewportId } from "./types";
import { queries } from "./viewports";

type MockViewportProviderProps = {
  /**
   * Either the current width, a viewport id or nothing.
   * If a viewport id is provided, the width will the the midpoint of the viewport boundaries.
   * If nothing is provided, the width will be -1 so that all media queries are ignored.
   */
  viewport?: ViewportId | number;
};

/**
 * Mocks out the viewport check for all media queries exported from `import { mediaQueries } from "@do/walrus"`.
 */
export const MockMediaQueryViewportProvider: React.FC<MockViewportProviderProps> = (props) => {
  const _matchMedia: MatchMedia = React.useCallback(
    (_mediaQuery, viewport) => {
      let pageWidth = 0;

      if (typeof props.viewport === "string") {
        const viewport = queries[props.viewport];
        pageWidth = (viewport.min + viewport.max) / 2;
      } else {
        pageWidth = props.viewport ?? -1;
      }

      const min = viewport.min ?? 0;
      const max = viewport.max ?? Infinity;

      return {
        matches: pageWidth >= min && pageWidth <= max,
        subscribe: () => () => {
          /* noop */
        },
      };
    },
    [props.viewport]
  );

  return <ThemeProvider theme={{ _matchMedia }}>{props.children}</ThemeProvider>;
};
